export class Auditable{
    createdby?: number;
    createdtime?: String;
    modifiedby?: number;
    modifiedtime?: String;
}
